import { Stack, Typography, useTheme } from "@mui/material";
import { Info } from "lucide-react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const AdvisorRestrictionBanner = () => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			gap={1.2}
			px={1.6}
			py={1.2}
			sx={{ bgcolor: theme.palette.blue[100] }}
		>
			<Stack sx={{ pt: "2px", flexShrink: 0 }}>
				<Info size={20} color={theme.palette.blue[600]} />
			</Stack>
			<Typography variant="body1" color={theme.palette.grey[800]} flex={1}>
				{t(Resources.Settings.NotificationSettings.Banner.text)}
			</Typography>
		</Stack>
	);
};
